import { useState } from 'react';
import { Link, useParams } from 'react-router';

import { useCan } from '@/shared/session/profiles';
import { useSupplier } from '@/shared/tariffs/useTariffs';
import { Button } from '@/shared/ui/Button';
import { ErrorMessage } from '@/shared/ui/ErrorMessage';
import { ArrowLeftIcon, PenIcon } from '@/shared/ui/icons';
import { PageHeader } from '@/shared/ui/PageHeader';
import { Spinner } from '@/shared/ui/Spinner';

import { CatalogsCard } from './Catalogs';
import { ConditionsCard } from './Conditions';
import { PriceListsCard } from './PriceLists';
import { SupplierDialog } from './SupplierDialog';

/** The file of one supplier: its catalogs (contract v10.49), its tariffs and its conditions
 * (contract v10.48). The catalogs first: «lo que se va a manejar principalmente» (07/10). */
export function SupplierPage() {
  const { supplierId } = useParams();
  const supplier = useSupplier(supplierId);
  const manage = useCan('manage_documents');
  const [editing, setEditing] = useState(false);

  const back = (
    <Link to="/documentos" className="text-ink-3 hover:text-ink inline-flex items-center gap-1">
      <ArrowLeftIcon size={14} /> Documentos
    </Link>
  );

  if (supplier.isPending) return <Spinner variant="block" label="Cargando el proveedor" />;
  if (supplier.isError) {
    return (
      <>
        <PageHeader title="Proveedor" back={back} />
        <ErrorMessage error={supplier.error}>No se pudo cargar el proveedor</ErrorMessage>
      </>
    );
  }
  const data = supplier.data;

  return (
    <>
      <PageHeader
        title={data.name}
        back={back}
        description={
          (data.domains ?? []).length
            ? `Escribe desde ${(data.domains ?? []).join(', ')}`
            : undefined
        }
        actions={
          manage ? (
            <Button
              variant="secondary"
              icon={<PenIcon size={16} />}
              onClick={() => setEditing(true)}
            >
              Editar
            </Button>
          ) : undefined
        }
      />
      {data.notes ? (
        <p className="text-ink-2 -mt-2 text-[14px] whitespace-pre-line">{data.notes}</p>
      ) : null}
      {editing ? <SupplierDialog supplier={data} onDone={() => setEditing(false)} /> : null}
      <CatalogsCard supplier={data} />
      <PriceListsCard supplier={data} />
      <ConditionsCard supplier={data} />
    </>
  );
}
